let _ = require('underscore');
let i18n = require('./i18n');

/***
Mixin to add scoped internationalization support
**/
let mixin = {
	beforeCreate() {
		this.language = _.assign({}, i18n);
	},
	data: function () {
		return {
			i18n: this.language.getLanguageSet(this.language.defaultLanguage)
		};
	},
	methods: {
		setLanguage: function (code) {
			_.assign(this.i18n, this.language.getLanguageSet(code));
		}
	}
};

module.exports = mixin;
